module.exports = __webpack_public_path__ + "img/079cd034b6eaf7b18e3c459eb7966aac.4163ae9a.webp";